/* eslint-disable */
import * as Types from '../../../models/schema';

import { ExceptionFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateExceptionVariablesDTO = Types.Exact<{
  data: Types.ExceptionCreateInputDTO;
}>;


export type CreateExceptionDTO = (
  { __typename?: 'Mutation' }
  & { createOneException: (
    { __typename?: 'Exception' }
    & ExceptionFragmentDTO
  ) }
);


export const CreateExceptionDocumentDTO = gql`
    mutation createException($data: ExceptionCreateInput!) {
  createOneException(data: $data) {
    ...exceptionFragment
  }
}
    ${ExceptionFragmentDTO}`;
export type CreateExceptionMutationFnDTO = Apollo.MutationFunction<CreateExceptionDTO, CreateExceptionVariablesDTO>;

/**
 * __useCreateException__
 *
 * To run a mutation, you first call `useCreateException` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateException` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createException, { data, loading, error }] = useCreateException({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateException(baseOptions?: Apollo.MutationHookOptions<CreateExceptionDTO, CreateExceptionVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionDTO, CreateExceptionVariablesDTO>(CreateExceptionDocumentDTO, options);
      }
export type CreateExceptionHookResult = ReturnType<typeof useCreateException>;
export type CreateExceptionMutationResultDTO = Apollo.MutationResult<CreateExceptionDTO>;
export type CreateExceptionMutationOptionsDTO = Apollo.BaseMutationOptions<CreateExceptionDTO, CreateExceptionVariablesDTO>;